import React from "react" 
import { useTranslation } from "react-i18next"
export default function ButtonGroupPlaceStatus({
icon,
text,
classActive,
onClick
}){
    const {t} = useTranslation("hours.vacances")
    const className = {
        normal:"arh-text-[#292929] !arh-bg-white arh-border-[#B0BEC5]",
        inplace:"arh-border-[#FFC6AE] arh-text-[#F55611] arh-bg-[#FFEFE8] ",
        remote:"arh-bg-[#FFD4E0] arh-text-[#ef3b60] arh-border-[#ED6581]"
    }
    return (
        <button className={`arh-rounded-lg arh-flex arh-justify-between arh-items-center arh-border arh-border-solid arh-px-[30px] arh-py-4 arh-w-40 ${className[classActive]} arh-transition arh-ease-in arh-duration-200`} onClick={onClick}>
            {icon}
            <span className="arh-block arh-font-poppins arh-font-medium arh-text-xs">{t(text)}</span>
        </button>
    )
}